"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridToggleMenu = exports.updateHiddenColumns = exports.toggleMenuItemId = exports.toggleButtonId = exports.togglerId = exports.toggleButtonBoxId = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const controls_1 = require("../../controls");
const helpers_1 = require("../../helpers");
const ToggleMenu_1 = require("../../helpers/components/ToggleMenu/ToggleMenu");
const Menu_1 = require("../../Menu");
const Popover_1 = require("../../Popover");
const features_1 = require("../features");
const DotsIcon_1 = require("../icons/DotsIcon");
const filterWithoutFakeColumns_1 = require("../utils/filterWithoutFakeColumns");
exports.toggleButtonBoxId = 'grid-toggle-button-box';
exports.togglerId = 'grid-toggler';
exports.toggleButtonId = 'grid-toggle-button';
exports.toggleMenuItemId = 'grid-toggle-menu-item';
const MAX_HEIGHT_MENU = '560px';
const ButtonBox = styled_components_1.default.div `
    position: absolute;
    top: 0;
    right: 0;
    box-sizing: border-box;
    background-color: #ffffff;

    display: flex;
    align-items: center;

    height: ${({ headerHeight }) => `${headerHeight - 2}px`};

    ${({ hasVerticalScroll, scrollbarWidth }) => hasVerticalScroll &&
    (0, styled_components_1.css) `
            padding-right: ${scrollbarWidth}px;
        `}
`;
const Button = styled_components_1.default.button `
    border: none;
    background: none;
    height: ${helpers_1.GRID_TOGGLE_BUTTON_WIDTH}px;
    width: ${helpers_1.GRID_TOGGLE_BUTTON_WIDTH}px;
    padding: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    &:focus,
    &:hover,
    &:active {
        outline: none;
    }

    ${({ isActive, theme }) => isActive
    ? (0, styled_components_1.css) `
                  background-color: ${theme.colorHighlightDark};
              `
    : (0, styled_components_1.css) `
                  &:hover {
                      background-color: ${theme.colorHighlightLight};
                  }
                  &:active {
                      background-color: ${theme.colorHighlightDark};
                  }
              `}
`;
const ToggleBtn = ({ toggleToggler, showToggler, togglerBtn, headerHeight, scrollbarWidth, hasVerticalScroll, disabled }) => (react_1.default.createElement(ButtonBox, { "data-selector-id": exports.toggleButtonBoxId, headerHeight: headerHeight, scrollbarWidth: scrollbarWidth, hasVerticalScroll: hasVerticalScroll },
    react_1.default.createElement(Button, { "data-selector-id": exports.toggleButtonId, onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleToggler();
        }, isActive: showToggler, ref: togglerBtn, disabled: disabled },
        react_1.default.createElement(DotsIcon_1.DotsIcon, { isDisabled: disabled }))));
const updateHiddenColumns = ({ key, isShow, hiddenColumns }) => {
    return isShow ? hiddenColumns.filter((i) => i !== key) : hiddenColumns.concat(key);
};
exports.updateHiddenColumns = updateHiddenColumns;
const TogglerMenu = (0, styled_components_1.default)(Menu_1.Menu) `
    max-height: ${MAX_HEIGHT_MENU};
`;
const GridToggler = ({ onClick, columns, hiddenColumns }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, columns.map((column, index) => {
        if (!column.props.notToggleable) {
            const checked = hiddenColumns.includes(column.key);
            return (react_1.default.createElement(ToggleMenu_1.ToggleMenuItem, { key: `${column.key}-toggler`, "data-selector-id": exports.toggleMenuItemId, title: column.props.title, isChecked: !checked, onChange: () => {
                    const currentColumn = {
                        isShow: checked,
                        toggledIndex: index,
                        columnId: column.props.columnId
                    };
                    onClick((0, exports.updateHiddenColumns)({
                        key: column.key,
                        isShow: checked,
                        hiddenColumns
                    }), currentColumn);
                } }));
        }
        return null;
    })));
};
const GridToggleMenu = () => {
    const { state: { columns, headerHeight, scrollbarWidth, hasVerticalScroll, disabled } } = (0, react_1.useContext)(features_1.GridContext);
    const { hiddenColumns, setHiddenColumns, onColumnToggle } = (0, features_1.useGridToggleableContext)();
    const notFakeColumns = columns.filter(filterWithoutFakeColumns_1.filterWithoutFakeColumns);
    const [control] = (0, controls_1.useDropdown)({
        popoverConfig: [
            {
                xAxis: Popover_1.X_AXIS.insideRight,
                yAxis: Popover_1.Y_AXIS.outsideBottom,
                offsetY: (headerHeight - helpers_1.GRID_TOGGLE_BUTTON_WIDTH) / 2
            },
            {
                xAxis: Popover_1.X_AXIS.insideRight,
                yAxis: Popover_1.Y_AXIS.outsideTop,
                offsetY: helpers_1.SHADOWS_NORMAL_BLUR_RADIUS - (headerHeight - helpers_1.GRID_TOGGLE_BUTTON_WIDTH) / 2
            }
        ],
        renderControl: ({ button, isActive }) => (react_1.default.createElement(ToggleBtn, { showToggler: isActive, togglerBtn: button.ref, toggleToggler: button.onMouseDown, headerHeight: headerHeight, scrollbarWidth: scrollbarWidth, hasVerticalScroll: hasVerticalScroll, disabled: disabled })),
        renderPopover: ({ popover, content }) => (react_1.default.createElement(TogglerMenu, Object.assign({}, popover, { "data-selector-id": exports.togglerId }), content)),
        renderContent: () => (react_1.default.createElement(GridToggler, { columns: notFakeColumns, hiddenColumns: hiddenColumns, onClick: (hiddenColumns, currentColumn) => {
                setHiddenColumns(hiddenColumns);
                onColumnToggle(currentColumn);
            } }))
    });
    return control;
};
exports.GridToggleMenu = GridToggleMenu;
//# sourceMappingURL=GridToggleMenu.js.map